import { tokenStore } from '../platform/tokenStore';

export function getAuthToken() {
  try {
    const raw = tokenStore.getAccessToken() || '';
    // Socket.IO receives a raw JWT in handshake.auth.token, never an HTTP
    // Authorization value. Keep REST callers compatible with either storage form.
    return String(raw).trim().replace(/^Bearer\s+/i, '').trim();
  } catch {
    return '';
  }
}

export function getAuthUserSnapshot() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    return {
      id: parsed?._id || parsed?.id || '',
      fullName: parsed?.fullName || parsed?.name || '',
      username: parsed?.username || '',
      zodiacSign: parsed?.zodiacSign || parsed?.sign || '',
      avatar:
        parsed?.avatarUrl ||
        parsed?.profilePicture ||
        parsed?.photoURL ||
        parsed?.image ||
        '',
    };
  } catch {
    return null;
  }
}
